import React from 'react'
import Drawer from '../../../components/common/Drawer'
import { useForm } from 'react-hook-form'
import Input from '../../../components/form/input/InputField'
import Label from '../../../components/form/Label'
import TextArea from '../../../components/form/input/TextArea'

const ProfessionalCreate = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const handleSave = (values: any) => {}

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title='Adicionar profissional'
            handleSave={() => formRef.current?.requestSubmit()}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                <div className='space-y-3'>
                    <div>
                        <Label>
                            Nome <span className='text-error-500'>*</span>{' '}
                        </Label>
                        <Input {...form.register('name', { required: true })} placeholder='Nome' />
                    </div>
                    <div>
                        <Label>Apelido</Label>
                        <Input {...form.register('nickname')} placeholder='Apelido' />
                    </div>
                    <div>
                        <Label>Título</Label>
                        <Input {...form.register('title')} placeholder='Título' />
                    </div>
                    <div>
                        <Label>Telefone</Label>
                        <Input {...form.register('phone')} placeholder='Telefone' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                    <div>
                        <Label>Descrição</Label>
                        <TextArea placeholder='Descrição' />
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

export default ProfessionalCreate
